module.exports = __webpack_public_path__ + "static/IBMPlexSans-SemiBold-41c01fa0bf4b93203edca754a8c81e68.woff2";